/**
 * Shared column-sort comparator for client-side table sorting.
 *
 * Nulls/undefined always sort to the end regardless of direction, so a
 * column with blank cells doesn't put them first on an ascending sort.
 */

export type SortDirection = 'asc' | 'desc';
export type SortValueType = 'string' | 'number' | 'date';

export function compareValues(
  a: unknown,
  b: unknown,
  direction: SortDirection,
  type: SortValueType = 'string'
): number {
  const aEmpty = a === null || a === undefined || a === '';
  const bEmpty = b === null || b === undefined || b === '';
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  const sign = direction === 'asc' ? 1 : -1;

  if (type === 'number') {
    return (Number(a) - Number(b)) * sign;
  }

  if (type === 'date') {
    return (new Date(a as string | number | Date).getTime() - new Date(b as string | number | Date).getTime()) * sign;
  }

  return String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true }) * sign;
}
